import { createFileRoute } from "@tanstack/react-router";
import PermisosPanel from "@/components/admin/PermisosPanel";

export const Route = createFileRoute("/admin/permisos")({
  component: PermisosPanel,
});
